import axios from 'axios'

const UPDATE = 'UPDATE'
const RESET = 'RESET'
const UPDATE_STATS = 'UPDATE_STATS'
const RESET_STATS = 'RESET_STATS'
const UPDATE_PURCHASES = 'UPDATE PURCHASES'
const FETCH_DEVICES = 'FETCH_DEVICES'

const API_URL = process.env.API_URL

export const sharedAttrNames = ['city', 'country', 'location', 'birth', 'gender', 'licence', 'description']

const actions = {
  async fetch ({ commit }, id) {
    const response = await axios.get(API_URL + '/user', { params: { 'user': id } })
    commit(UPDATE, parseUser(response.data.data))
  },
  clear ({ commit }) {
    commit(RESET)
  },
  fetchStats ({ commit }, id) {
    axios.get(API_URL + '/user/stats', {
      params: { 'user': id }
    }).then(response => {
      commit(UPDATE_STATS, parseStats(response.data.data))
    })
  },
  clearStats ({ commit }) {
    commit(RESET_STATS)
  },
  fetchPurchases ({ commit }, id) {
    axios.get(API_URL + '/user/purchases', {
      params: { 'user': id }
    }).then(response => {
      commit(UPDATE_PURCHASES, parsePurchases(response.data.data))
    })
  },
  async fetchDevices ({ commit }, id) {
    const { data: { data } } = await axios.get(API_URL + '/user/devices', {
      params: { user: id }
    })
    commit(FETCH_DEVICES, data)
  },
  async deleteDevices ({ commit, dispatch }, id) {
    await axios.delete(API_URL + '/user/devices', {
      params: { user: id }
    })
    await dispatch('fetchDevices', id)
  },
  async setRole ({ commit, state, dispatch }, role) {
    await axios.post(API_URL + '/user/role', {
      email: state.email,
      role: role
    })
    await dispatch('fetch', state.id)
  }
}

const mutations = {
  [UPDATE] (state, user) {
    Object.assign(state, user)
  },
  [RESET] (state) {
    Object.assign(state, getInitialState())
  },
  [UPDATE_STATS] (state, stats) {
    state.stats = stats
  },
  [RESET_STATS] (state) {
    state.stats = getInitialStats()
  },
  [UPDATE_PURCHASES] (state, purchases) {
    state.purchases = purchases
  },
  [FETCH_DEVICES] (state, devices) {
    state.devices = devices
  }
}

export default {
  namespaced: true,
  state: getInitialState(),
  actions,
  mutations
}

function getInitialState () {
  return {
    id: null,
    email: null,
    name: null,
    registeredAt: null,
    avatar: null,
    terms: 0,
    newsletter: 0,
    billingAddress: {},
    privateAddress: {},
    profile: getInitialProfile(),
    stats: getInitialStats(),
    purchases: getInitialPurchases(),
    devices: []
  }
}

function getInitialProfile () {
  return {
    attrNames: sharedAttrNames,
    access: {},
    entities: {}
  }
}

function parseUser (userData) {
  let {
    info: {
      registration_time: registeredAt,
      image: avatar
    },
    user_id: id,
    email,
    options: {
      terms,
      newsletter
    },
    billing_address: billingAddress,
    private_address: privateAddress,
    language,
    shared,
    role,
    stages
  } = userData

  let profile = getInitialProfile()

  profile.attrNames.forEach((attrName) => {
    ;([ profile.entities[attrName], profile.access[attrName] ] = shared[attrName] || [])
  })

  let [ name ] = shared['user_name']

  return {
    id,
    email,
    name,
    role,
    stages,
    registeredAt,
    language,
    avatar,
    newsletter,
    terms,
    billingAddress,
    privateAddress,
    profile
  }
}

function getInitialStats () {
  return {
    quota: null,
    storage: []
  }
}

function parseStats (statsData) {
  let stats = getInitialStats()

  statsData.usedStorage.forEach((item) => {
    let key = Object.keys(item)[0]
    let data = { name: key }
    ;({ [key]: [ { count: data.count, usedspace: data.size } ] } = item)
    ;({ limits: { [key]: data.available } } = statsData)
    stats.storage.push(data)
  })

  stats.quota = statsData.quota

  return stats
}

function getInitialPurchases () {
  return []
}

function parsePurchases (purchasesData) {
  let purchases = getInitialPurchases()
  purchasesData.forEach((item) => {
    let purchase = {}
    ;({
      name: purchase.name,
      voucher: purchase.voucher,
      pay_method: purchase.pay_method,
      store_id: purchase.store_id,
      purchase_date: purchase.purchasedAt,
      feature_start_date: purchase.activatedAt
    } = item)
    purchases.push(purchase)
  })
  return purchases
}



// WEBPACK FOOTER //
// ./src/store/modules/userDetails.js